<div class="tab-gifts">
  <div class="grid">
    <div class="grid__m-4">
      <div class="label-reservations">
        <span>Izaberite datum</span>
      </div>
      <gr-date-picker [minDate]="minDate" [defaultDate]="urlParams.date ? urlParams.date : undefined" (dateSelected)="onSelectedDate($event)"></gr-date-picker>
    </div>
    <div class="grid__m-4">
    </div>
    <div class="grid__m-2">
      <button (click)="exportReservationsPdf()" class="zc-btn zc-btn--primary">
        <span>Štampaj PDF</span>
      </button>
    </div>
    <div class="grid__m-2">
      <button (click)="exportReservationsExcel()" class="zc-btn zc-btn--primary">
        <span>Štampaj Excel</span>
      </button>
    </div>
  </div>
  <div class="grid">
    <div class="grid__m-12">
      <div class="zc-table purchased-gift">
        <div class="zc-header-table">
          <div class="zc-header-row">
            <div class="zc-header-column">
              <span>ID</span>
            </div>
            <div class="zc-header-column">
              <span>Datum održavanja</span>
            </div>
            <div class="zc-header-column">
              <span>Datum kreiranja</span>
            </div>
            <div class="zc-header-column">
              <span>Ime i prezime</span>
            </div>
            <div class="zc-header-column">
              <span>Email</span>
            </div>
            <div class="zc-header-column">
              <span>Broj telefona</span>
            </div>
            <div class="zc-header-column column-buttons">
            </div>
          </div>
        </div>
        <div class="zc-content-table">
          <div class="zc-content-row" *ngFor="let reservation of reservations">
            <div class="zc-content-column">
              <span>{{ reservation.id }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservation.date | date: 'dd.MM.yyyy' }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservation.created_at | date: 'dd.MM.yyyy' }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservation.user.full_name }}</span>
            </div>
            <div class="zc-content-column">
              <span>{{reservation.user.email}}</span>
            </div>
            <div class="zc-content-column">
              <span>{{ reservation.user.phone }}</span>
            </div>
            <div class="zc-content-column column-buttons">
              <div class="buttons-group">
                <div class="wrapper-button" [routerLink]="[PAGES_AND_PATHS.singleReservation.pagePath, reservation.id]">
                  <i class="fa-solid fa-eye"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="grid">
    <div class="grid__m-12">
      <gr-pagination
        *ngIf="reservations.length"
        [currentPage]="reservationPagination?.currentPage"
        [pagId]="'js-reservations-company-table-pagination'"
        [perPage]="reservationPagination?.perPage"
        [totalItems]="reservationPagination?.totalItems"
        (pageChanged)="onPageChanged($event)">
      </gr-pagination>
    </div>
  </div>
</div>


